<template>
    <div class="modal-content px-4">
        <div class="modal-header justify-content-center border-0">
            <div class="d-flex flex-column justify-content-center align-items-center" style="color: #137FEC;">
                <div class="mt-4" style="width: 60px; height: 60px; padding: 14px; background: #E7F2FD; border-radius: 90em;">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path 
                            d="M9.6002 30.4C8.9402 30.4 8.3752 30.165 7.9052 29.695C7.4352 29.225 7.2002 28.66 7.2002 28V3.99998C7.2002 3.26664 7.41686 2.68331 7.8502 2.24998C8.28353 1.81664 8.86686 1.59998 9.6002 1.59998H22.4002C23.0602 1.59998 23.6252 1.83498 24.0952 2.30498C24.5652 2.77498 24.8002 3.33998 24.8002 3.99998V8.79998C25.2446 8.79998 25.6224 8.95553 25.9335 9.26664C26.2446 9.57775 26.4002 9.95553 26.4002 10.4V13.6C26.4002 14.0444 26.2446 14.4222 25.9335 14.7333C25.6224 15.0444 25.2446 15.2 24.8002 15.2V28C24.8002 28.66 24.5652 29.225 24.0952 29.695C23.6252 30.165 23.0602 30.4 22.4002 30.4H9.6002ZM9.6002 28H22.4002V3.99998H9.6002V28ZM16.8502 22.057C17.0835 21.8283 17.2002 21.545 17.2002 21.207C17.2002 20.869 17.0859 20.5833 16.8572 20.35C16.6285 20.1166 16.3452 20 16.0072 20C15.6692 20 15.3835 20.1143 15.1502 20.343C14.9169 20.5716 14.8002 20.855 14.8002 21.193C14.8002 21.531 14.9145 21.8166 15.1432 22.05C15.3719 22.2833 15.6552 22.4 15.9932 22.4C16.3312 22.4 16.6169 22.2856 16.8502 22.057ZM14.8002 18.4H17.2002V9.59998H14.8002V18.4Z" fill="#137FEC"/>
                    </svg>
                </div>
                <h5 class="mt-3">{{ $t('verify_phone_title') }}</h5>
                <div class="form-group">
                    <p class="text-center" style="color: #070A28;" v-html="$t('verify_phone_text')"></p>
                </div>
            </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
            <button type="button" class="lisa-btn-fit active m-auto mb-3" @click="goToVerify()">
                {{ $t('agree_to_verify') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "PhoneVerifyModal",
    methods: {
        goToVerify() {
            this.$emit('resolve');
            this.$router.push('/account-verify-phone');
        }
    }
}
</script>

<style scoped>
.modal-content {
    color: #151522;
    font-size: medium;
    border-radius: 16px;
    box-shadow: 0px 4px 0px 0px #E7E7E740 inset, 4px 4px 0px 0px #00000012;
}
</style>